import { SUBSCRIPTION_URL, USER_URL } from "../../helpers/api.routes";
import { instance, requests } from "../../helpers/api.services";
import { CsvExportParams } from "../../shared/components/CsvExportModal";

export const UserService = {
  getAll: (params: any) => requests.get(`${USER_URL}`, params),
  create: (params: any) => requests.post(`${USER_URL}`, params, true),
  getSingle: (id: number) => requests.get(`${USER_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.put(`${USER_URL}/${id}`, params, true),
  changePassword: (params: any, id: number) =>
    requests.put(`${USER_URL}/change-password/${id}`, params),
  delete: (id: number) => requests.delete(`${USER_URL}/${id}`),
  deleteDocument: (id: number) => requests.delete(`${USER_URL}/document/${id}`),
  impersonate: (id: number) => requests.post(`${USER_URL}/${id}/impersonate`, {}),
  exportCsv: (params: CsvExportParams) =>
    instance.get<Blob>(`${USER_URL}/export`, { params, responseType: 'blob' }),
};

export const SubscriptionService = {
  getAll: (userId: number) =>
    requests.get(`${SUBSCRIPTION_URL}/user-subscriptions/current/${userId}`),
  assignPackage: (params: { user: number; package: number; duration: string }) =>
    requests.post(`${SUBSCRIPTION_URL}/user-subscriptions/assign-package`, params),
  getPackages: (params:any) => requests.get(`${SUBSCRIPTION_URL}/packages`,params),
  getSubscriptionHistory: (userId: number) =>
    requests.get(`${SUBSCRIPTION_URL}/user-subscriptions/subscription-history/${userId}`), // New method
  cancelAtPeriodEnd: (userId: number) =>
    requests.post(`${USER_URL}/subscriptions/cancel-at-period-end/${userId}`, {}),
  renewSubscription: (userId: number) =>
    requests.post(`${USER_URL}/subscriptions/renew-subscription/${userId}`, {}),
  cancelImmediately: (userId: number) =>
    requests.post(`${USER_URL}/subscriptions/cancel-immediately/${userId}`, {}),
  cleanup: (userId: number) =>
    requests.post(`${USER_URL}/subscriptions/cleanup/${userId}`, {}),
  getAvailablePackages: () =>
    requests.get(`${USER_URL}/subscriptions/available-packages`),
  getStripeUrl: (packageId: number, params: {
    userId: number,
    subscriptionPackage: number,
    subscriptionDuration: string,
    successUrl: string,
    cancelUrl: string,
    promoCode?: string
  }) =>
    requests.post(`${USER_URL}/subscriptions/subscribe-get-stripe-url/${packageId}`, params),
};